<template>
    <div class="page">
        <div class="page_bg">
            <div  class="pagebox">
                <div class="page_title">{{page.title}}</div>
                <div class="page_date">{{page.create_at}}</div>
            </div>
        </div>
        <div id="page_content" v-html='page.content' ></div>
        
    </div>
</template>
<script>

export default {
    components: {
    
  },
    props:  [
        "page",
        "router_name",
    ],
    data () {
    return {
      news: []
    }
  },    
  mounted(){
    //   var table = document.getElementsByTagName('table')
    //   console.log(table.style.width)
  }
}
</script>
<style>
.page .pagebox{
    text-align: center;
    max-width: 1000px;
    margin: 0 auto;
    padding: 35px 0;
}
.page .page_bg{
    background: #f5f5f5;
    width: 100%;
    margin: 35px 0;
}
.page .page_title{
    font-size: 27px;
    color: #00a0e9;
    font-weight: 700;
    line-height: 40px;
    margin: 0 15px;
}
.page .page_date{
    font-size: 17px;
    margin-top: 30px; 
}
.page #page_content{
    max-width: 1000px;
    margin:  0  auto;
    padding: 5px;
    /* overflow-x: auto; */
}
.page #page_content table{
   width: 100% !important;
   /* table-layout:fixed; */
}
.page #page_content table td{
   width: auto !important;
}
.page #page_content table td p{
   word-break:break-all !important;
}
.page #page_content img{
    max-width: 100%;
    margin: 0 auto;
    height: auto !important;
}
.page #page_content table{
    max-width: 800px;
}
@media (max-width: 768px){
    .page #page_content{
        padding: 0 5px;
    }
    .page td{
        white-space: pre-wrap !important;
        word-break: break-all !important;
    }
    
}
</style>


